import experienceTagStore from '@store/experience-tag-store.ts';
import { PopulatedExperienceTag } from '@/schemas/experience-tag-schema.ts';

export interface ExperienceTagDetailsLoaderReturn {
	populatedTag: PopulatedExperienceTag;
}

export async function ExperienceTagDetailsLoader(
	experienceTagId: string
): Promise<ExperienceTagDetailsLoaderReturn | null> {
	let tag = experienceTagStore.populatedExperienceTag(+experienceTagId);

	if (tag) {
		void experienceTagStore.getPopulatedExperienceTag(+experienceTagId);
		return { populatedTag: tag };
	} else {
		await experienceTagStore.getPopulatedExperienceTag(+experienceTagId);
	}

	tag = experienceTagStore.populatedExperienceTag(+experienceTagId);

	if (!tag) {
		throw new Response('Not Found', { status: 404 });
	}

	return { populatedTag: tag };
}
